"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    DefaultModalHeader: ()=>DefaultModalHeader
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const external_PennyToolTip_js_namespaceObject = require("./PennyToolTip.js");
var external_PennyToolTip_js_default = /*#__PURE__*/ __webpack_require__.n(external_PennyToolTip_js_namespaceObject);
const DefaultModalHeader = (props)=>{
    const modalHeaderRef = (0, external_react_namespaceObject.useRef)(null);
    (0, external_react_namespaceObject.useEffect)(()=>{
        if (props.onDefaultModalHeaderRendered) props.onDefaultModalHeaderRendered();
    }, []);
    (0, external_react_namespaceObject.useEffect)(()=>{
        modalHeaderRef.current.querySelectorAll('button')[1].style.display = 'none';
    }, [
        props.speechEnabled
    ]);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
        ref: modalHeaderRef,
        "data-testid": "chat-header-box",
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.ChatHeader, {
            onClose: props.onClose,
            onMinimize: props.onClose,
            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_PennyToolTip_js_default(), {})
        })
    });
};
exports.DefaultModalHeader = __webpack_exports__.DefaultModalHeader;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "DefaultModalHeader"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
